import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export function NotFoundPage() {
  return <main className="not-found"><span>404</span><h1>This page wandered off the map.</h1><p>Head back to your dashboard and keep building.</p><Link className="button button-primary" to="/"><ArrowLeft />Back home</Link></main>;
}
